<template>
  <v-card outlined class="mx-auto">
    <v-card-title>
      <p>{{ getTitleContact || '' }}</p>
      <v-spacer />
      <v-tooltip top v-if="indexCustomer > -1 && customer.vhUserId && checkAuthorization('every-order_read')">
        <template v-slot:activator="{ on: onTooltip }">
          <v-btn
              style="margin-top: -20px; margin-right: -20px;"
              text
              v-on="onTooltip"
          >
            <v-icon>mdi-information</v-icon>
          </v-btn>
        </template>

        <span>{{customer.vhUserId}}</span>
      </v-tooltip>
<!--      <v-btn-->
<!--          style="margin-top: -20px; margin-right: -20px;"-->
<!--          v-if="indexCustomer > -1 && !customer.isMainCustomer && checkAuthorization('every-order_read')"-->
<!--          @click="onClickReloadCourseCustom(customer.customerId)"-->
<!--          text-->
<!--      >-->
<!--        <v-icon>mdi-book-open</v-icon>-->
<!--      </v-btn>-->
      <v-btn
        style="margin-top: -20px; margin-right: -20px;"
        v-if="indexCustomer > -1 && !customer.isMainCustomer && !customer.vhUserId"
        @click="checkCanDeleteCustomer(customer.customerId)"
        text
      >
        <v-icon>mdi-close-box</v-icon>
      </v-btn>
    </v-card-title>
    <contact-card
      v-if="titleContact === 'CONTACT'"
      :contactColumns="contactColumns"
      :data-form="dataForm"
      :showChat="showChat"
      :listPhoneRelated="listPhoneRelated"
    />
    <parent-card
      v-if="titleContact === 'PARENT'"
      :contactColumns="contactColumns"
      :data-form="dataForm"
      :customer="customer"
      :indexCustomer="indexCustomer"
    />
    <child-card
      v-if="titleContact === 'CHILD'"
      :contactColumns="contactColumns"
      :data-form="dataForm"
      :customer="customer"
      :indexCustomer="indexCustomer"
    />
    <customer-card
      v-if="titleContact === 'CUSTOMER'"
      :contactColumns="contactColumns"
      :contact-sources="contactSources"
      :users="users"
      :product-groups="productGroups"
      :data-form="dataForm"
      :contactStatusList="contactStatusList"
      :schoolLevels="schoolLevels"
      :types="types"
    />
  </v-card>
</template>

<script>
import ContactCard from './ContactCard';
import ParentCard from './ParentCard';
import ChildCard from './ChildCard';
import CustomerCard from './CustomerCard';
import { contactDetail } from '../../../helpers/constants';
import RepositoryFactory from '../../../repositories/RepositoryFactory';
import TokenService from "@/helpers/token";
const ContactRepository = RepositoryFactory.get('contact');

export default {
  components: { ContactCard, ParentCard, ChildCard, CustomerCard },
  props: {
    contactColumns: {
      type: Object,
      default: () => ({})
    },
    customer: {
      type: Object,
      default: () => {}
    },
    indexCustomer: {
      type: Number,
      default: -1
    },
    titleContact: {
      type: String,
      default: ''
    },
    contactSources: {
      type: Array,
      default: () => []
    },
    users: {
      type: Array,
      default: () => []
    },
    productGroups: {
      type: Array,
      default: () => []
    },
    dataForm: {
      type: Object,
      default: () => {}
    },
    contactStatusList: {
      type: Array,
      default: () => []
    },
    showChat: {
      type: Boolean,
      default: false
    },
    listPhoneRelated: {
      type: String,
      default: ''
    },
    schoolLevels: {
      type: Array,
      default: () => []
    },
    types: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      contactDetail
    };
  },
  computed: {
    getTitleContact() {
      if (this.indexCustomer > 0) {
        return (
          this.contactDetail[this.titleContact] + ` ${this.indexCustomer + 1}`
        );
      }
      return this.contactDetail[this.titleContact];
    }
  },
  methods: {
    async checkCanDeleteCustomer(customerId){
      let res = await ContactRepository.checkCanDeleteCustomer(customerId);
      if(res.data.canRemove){
        this.onClickRemoveCustomer(customerId)
      } else {
        this.$swal({
          text: res.data.message,
          type: 'warning',
          title: 'Thông báo !',
          icon: 'warning',
        })
      }
    },
    async onClickRemoveCustomer(customerId) {
      if (!customerId) {
        return;
      }
      const index = this.dataForm.customers.findIndex(
        customer => customer.customerId === customerId
      );
      if (index === -1) {
        return;
      }
      const customerTemp = this.dataForm.customers[index];
      const message =
        customerTemp.position === 'child'
          ? 'Xoá thông tin của con'
          : 'Xoá thông tin của phụ huynh';
      this.$swal({
        title: message,
        text: 'Bạn có thực sự muốn xoá ?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy bỏ'
      }).then(async result => {
        if (result.value && !customerTemp.isNew) {
          const loading = this.$loading.show();
          const response = await ContactRepository.deleteContactCustomer(customerId);
          loading.hide();
          if (response.error) {
            this.$swal({
              type: 'error',
              title: 'Lỗi !',
              text: _.get(response, 'message', '')
            });
          } else {
            customerTemp.isDeleted = true;
            customerTemp.courseRegister = [];
            this.dataForm.customers.splice(index, 1);
            if (this.$route.params.id && !_.get(customerTemp, 'isNew', true)) {
              this.dataForm.customers.push(customerTemp);
            }
          }
        }
        this.dataForm.customers.splice(index, 1);
      });
    },
    async onClickReloadCourseCustom (customerId) {
      const loading = this.$loading.show();
      const response = await ContactRepository.reloadCourseOfCustomer(customerId);
      loading.hide();
      if (response.error) {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(response, 'message', '')
        });
      } else {
        this.$swal({
              title: 'Cập nhật khóa học thành công!',
              confirmButtonText: 'OK',
              timer: 3000
            },
        ).then(() => {
          Bus.$emit('contact-source-list-reload')
        })
      }
    }
  }
};
</script>
